import React, { useEffect, useState } from "react";
import data from "./servicesData.json";
import { useParams , useNavigate } from "react-router-dom";
import HeroBanner from "../common/HeroBanner";
import img from '../../../Assets/Services/service1A.png'

const services = data.services;


const icons = [
  {
    id: 1,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4"
      >
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
      </svg>
    ),
  },
  {
    id: 2,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" />
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07M8.46 8.46a5 5 0 0 0 0 7.07" />
      </svg>
    ),
  },
  {
    id: 3,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4"
      >
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    id: 4,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4"
      >
        <path d="M2 20h20M4 20V10l6-6 2 2M14 20V8l6 4v8" />
        <path d="M10 20v-6h4v6" />
      </svg>
    ),
  },
  {
    id: 5,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4"
      >
        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
      </svg>
    ),
  },
  {
    id: 6,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4"
      >
        <ellipse cx="12" cy="5" rx="9" ry="3" />
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
      </svg>
    ),
  },
];

const ServiceDetailsPage = () => {
  const { serviceSlug, subSlug } = useParams();
  const navigate = useNavigate();
  const selectedService =
  services.find((s) => s.slug === serviceSlug) || services[0];
 const selectedSubService =
  selectedService?.subservices.find(
    (sub) => sub.slug === subSlug
  ) || selectedService?.subservices[0];

  // Handle service selection
  const handleServiceSelect = (service) => {
  navigate(`/services/${service.slug}`);
};

  const handleSubServiceSelect = (sub) => {
  navigate(`/services/${selectedService.slug}/${sub.slug}`);
};

useEffect(() => {
  // console.log("first",serviceSlug )
  if (!serviceSlug && services.length > 0) {
    navigate(`/services/${services[0].slug}`);
  }
    if (selectedService && !subSlug) {
    navigate(`/services/${selectedService.slug}/${selectedService.subservices[0].slug}`);
  }
}, [serviceSlug]);



  return (
    <>
    <HeroBanner subheading='Home / Our Services'/>
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">

      <div className=" px-4 sm:px-6 lg:px-12 py-8 md:py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar - Service Categories */}
          <div className="lg:w-[380px] flex-shrink-0">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 sticky top-6 overflow-hidden">
              <div className="p-4 bg-gradient-to-r from-blue-50 to-white border-b border-gray-200">
                <h2 className="font-bold xl:text-lg text-gray-900">
                  Service Categories
                </h2>
                <p className="text-sm lg:text-base text-gray-500 mt-1">
                  Select a category to explore
                </p>
              </div>
              <nav className="p-2">
                {services.map((service) => {
                  const isActive = selectedService?.slug === service.slug;
                  return (
                    <div key={service.id}>
                      <button
                        onClick={() => handleServiceSelect(service)}
                        className={`
                        w-full text-left px-6 py-3 rounded-lg mb-0.5
                        flex items-center gap-2.5 transition-all duration-150
                        ${
                          isActive
                            ? "bg-blue-50 text-blue-700"
                            : "text-black hover:bg-gray-50 hover:text-gray-900"
                        }
                      `}
                      >

                        {/* {icons.map((item)=>{
                         const serviceIcon = icons.find((icon) => icon.id === service.id);
                          return (
                            <span
                              className={`
                                w-7 h-7 rounded-md flex items-center justify-center text-sm flex-shrink-0
                                transition-colors duration-150
                                ${isActive ? "bg-blue-100" : "bg-gray-100"}
                              `}
                            >
                              {serviceIcon?.icon}
                            </span>
                          );
                          })} */}
                        <span
                          className={`flex-1 text-sm lg:text-base font-bold ${isActive ? "font-medium" : "font-normal"}`}
                        >
                          {service.name}
                        </span>
                        <svg
                          className={`w-3.5 h-3.5 flex-shrink-0 transition-all duration-200
                          ${isActive ? "rotate-90 text-blue-600 opacity-100" : "opacity-30"}`}
                          viewBox="0 0 16 16"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M6 4l4 4-4 4" />
                        </svg>
                      </button>

                      <div
                        className={`overflow-hidden transition-all duration-200 pl-4
                        ${isActive ? "max-h-96" : "max-h-0"}`}
                      >
                        <div className="border-l-2 border-blue-200 my-1 pb-1">
                          {service.subservices.map((sub) => {
                            const isSubActive =
                             selectedSubService?.slug === sub.slug;
                            return (
                              <button
                                key={sub.id}
                                onClick={() => handleSubServiceSelect(sub)}
                                className={`
                                w-full text-left px-3 py-1.5 rounded-md text-xs md:text-sm 
                                flex items-center gap-2 transition-all duration-150 font-semibold
                                ${
                                  isSubActive
                                    ? "bg-blue-100 text-blue-700 font-medium"
                                    : "text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                                }
                              `}
                              >
                                <span
                                  className={`w-1.5 h-1.5 rounded-full flex-shrink-0 transition-colors
                                ${isSubActive ? "bg-blue-600" : "bg-blue-200"}`}
                                />
                                {sub.name}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </nav>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1">
            {selectedService && selectedSubService ? (
              <div className="space-y-6">
                {/* Service Header */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-blue-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                        />
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-xl lg:text-2xl xl:text-3xl font-bold text-gray-900">
                        {selectedService.name}
                      </h2>
                      {selectedService.overview && (
                        <p className="text-gray-600 text-sm mt-1">
                          {selectedService.overview}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Sub-service Tabs */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                  {selectedSubService?.img && (
                      <div className="">
                        <img
                          src={selectedSubService.img}
                          alt={selectedSubService.name || "service image"}
                          className="w-full h-auto object-cover"
                        />
                      </div>
                    )}
                  {/* Sub-service Details */}
                  <div className="p-6 space-y-8">
                    {/* Title Section */}
                    <div>
                      <h3 className="text-xl md:text-2xl lg:text-4xl font-bold text-gray-900">
                        {selectedSubService.name}
                      </h3>
                      {selectedSubService.overview && (
                        <p className="text-gray-600 mt-3 leading-relaxed">
                          {selectedSubService.overview}
                        </p>
                      )}
                    </div>

                    {/* What We Do */}
                    <div className="bg-blue-200/30 rounded-xl p-6 border border-blue-200">
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-12 h-12 bg-blue-200 rounded-lg flex items-center justify-center">
                          <svg
                            className="w-8 h-8 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 10V3L4 14h7v7l9-11h-7z"
                            />
                          </svg>
                        </div>
                        <h4 className="text-lg md:text-xl font-bold text-gray-900">
                          What We Do
                        </h4>
                      </div>
                      <p className="text-gray-700 leading-relaxed">
                        {selectedSubService.what_we_do}
                      </p>
                    </div>

                    {/* Capabilities */}
                    {selectedSubService.capabilities &&
                      selectedSubService.capabilities.length > 0 && (
                        <div>
                          <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                              />
                            </svg>
                            Capabilities
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {selectedSubService.capabilities.map(
                              (capability, idx) => (
                                <div
                                  key={idx}
                                  className="flex items-start gap-2"
                                >
                                <span
                                  className={`h-7 w-7 inline-flex items-center justify-center bg-blue-800 rounded-full`}
                                >
                                    <svg
                                      className="text-white"
                                      width={18}
                                      height={18}
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      aria-hidden="true"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                      />
                                    </svg>
                                </span>
                                  <span className="text-gray-700 text-sm">
                                    {capability}
                                  </span>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      )}

                    {/* Industry Gaps */}
                    {selectedSubService.industry_gaps &&
                      selectedSubService.industry_gaps.length > 0 && (
                        <div className="bg-red-50/30 rounded-xl p-6 border border-red-100">
                          <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                            <svg
                              className="w-5 h-5 text-red-500"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                              />
                            </svg>
                            Industry Gaps We Address
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {selectedSubService.industry_gaps.map(
                              (gap, idx) => (
                                <div
                                  key={idx}
                                  className="flex items-start gap-2"
                                >
                                  <svg
                                    className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M6 18L18 6M6 6l12 12"
                                    />
                                  </svg>
                                  <span className="text-gray-700 text-sm">
                                    {gap}
                                  </span>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      )}

                    {/* Differentiators */}
                    {selectedSubService.differentiators &&
                      selectedSubService.differentiators.length > 0 && (
                        <div className="bg-green-50/30 rounded-xl p-6 border border-green-100">
                          <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                            <svg
                              className="w-5 h-5 text-green-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                              />
                            </svg>
                            Our Differentiators
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {selectedSubService.differentiators.map(
                              (diff, idx) => (
                                <div
                                  key={idx}
                                  className="flex items-start gap-2"
                                >
                                  <svg
                                    className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M5 13l4 4L19 7"
                                    />
                                  </svg>
                                  <span className="text-gray-700 text-sm">
                                    {diff}
                                  </span>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      )}

                    {/* Transformation Points */}
                    {selectedSubService.transformation_points &&
                      selectedSubService.transformation_points.length > 0 && (
                        <div>
                          <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                              />
                            </svg>
                            Transformation Points
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {selectedSubService.transformation_points.map(
                              (point, idx) => (
                                <div
                                  key={idx}
                                  className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg"
                                >
                                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                                    <span className="text-blue-600 text-xs font-bold">
                                      {idx + 1}
                                    </span>
                                  </div>
                                  <span className="text-gray-700 text-sm">
                                    {point}
                                  </span>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      )}

                    {/* How We Build */}
                    {selectedSubService.how_we_build &&
                      selectedSubService.how_we_build.length > 0 && (
                        <div>
                          <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                              />
                            </svg>
                            How We Build
                          </h4>
                          <div className="flex flex-wrap gap-2">
                            {selectedSubService.how_we_build.map(
                              (item, idx) => (
                                <span
                                  key={idx}
                                  className="px-3 py-1.5 bg-blue-50 text-blue-700 text-sm rounded-full"
                                >
                                  {item}
                                </span>
                              ),
                            )}
                          </div>
                        </div>
                      )}

                    {/* Business Impact / Results */}
                    {selectedSubService.business_impact &&
                      selectedSubService.business_impact.length > 0 && (
                        <div className="bg-gray-900 rounded-xl p-6 text-white">
                          <h4 className="text-lg font-semibold mb-4 flex items-center gap-2">
                            <svg
                              className="w-5 h-5 text-blue-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                              />
                            </svg>
                            Business Impact
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {selectedSubService.business_impact.map(
                              (impact, idx) => (
                                <div
                                  key={idx}
                                  className="flex items-center gap-2"
                                >
                                  <svg
                                    className="w-4 h-4 text-blue-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M5 13l4 4L19 7"
                                    />
                                  </svg>
                                  <span className="text-gray-200 text-sm">
                                    {impact}
                                  </span>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      )}

                    {/* Results Delivered */}
                    {selectedSubService.results_delivered &&
                      selectedSubService.results_delivered.length > 0 && (
                        <div className="bg-blue-50 rounded-xl p-6">
                          <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                              />
                            </svg>
                            Results We Deliver
                          </h4>
                          <div className="flex flex-wrap gap-2">
                            {selectedSubService.results_delivered.map(
                              (result, idx) => (
                                <span
                                  key={idx}
                                  className="px-3 py-1.5 bg-white text-gray-800 text-sm rounded-full shadow-sm"
                                >
                                  {result}
                                </span>
                              ),
                            )}
                          </div>
                        </div>
                      )}

                    {/* Result */}
                    {selectedSubService.result && (
                      <div className="border-t border-gray-200 pt-6">
                        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-6 text-white">
                          <div className="flex items-center gap-2 mb-2">
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span className="font-semibold">Key Outcome</span>
                          </div>
                          <p className="text-lg font-medium">
                            {selectedSubService.result}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* CTA Section */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 text-center">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Ready to Grow Your Carrier ?
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Let's discuss how our solutions can drive your digital
                    transformation journey.
                  </p>
                  <button 
                    onClick={()=>{
                      navigate("/contact");
                      window.scrollTo({
                        top:0,
                        behavior:"smooth"
                      })
                    }}
                  className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 shadow-sm">
                    Contact Our Experts
                  </button>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center">
                <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-10 h-10 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-900">
                  Select a service category
                </h3>
                <p className="text-gray-500 mt-1">
                  Choose a service from the sidebar to view details
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ServiceDetailsPage;
